import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { CompleteActionItemBanner } from 'Components/ComponentLibrary/Organisms/CompleteActionItemBanner';
import { ConnectionsPageActions } from 'Views/Page/Content/Templates/ConnectionsPageTemplate/ConnectionsPageActions';
import { ConnectionsSection } from 'Views/Page/Content/Templates/ConnectionsPageTemplate/ConnectionsSection';
import { navigateToPage } from 'Views/Page/Content/Templates';
import { dataAttrs } from 'Helpers/Testing';

export const ConnectionsPageTemplate = ({ resource }) => {
  const { loadModalCollectionByLink } = useModalContext();
  const { refreshPageContentCollection, loadPageContentLink } = usePageContentContext();

  useBoneBackgroundColor();

  const onAddInstitution = (rel) => loadPageContentLink(rel.link('related'));

  const onEditLineItemClick = useCallback((rel) => {
    const url = rel.link('related').url();
    if (rel.meta('modal') === 'true') return loadModalCollectionByLink(url);
    return navigateToPage(url, false);
  }, [loadModalCollectionByLink]);

  // if we unlink we want to refresh the page so we should the institution was removed
  const onUnlinkSuccess = () => {
    refreshPageContentCollection();
  };

  // If we refresh the institution we want to refresh the page so we get updated balances/sync timestamps
  const onActionSuccess = async () => {
    refreshPageContentCollection();
  };

  return (
    <>
      <CompleteActionItemBanner resource={resource} />
      <FDContentContainer maxWidth={'xl'} {...dataAttrs('page-template', resource)}>
        <FDStack direction={'column'} spacing={2} paddingY={2}>
          <PageHeader
            title={resource.attr('title')}
            subtitle={resource.attr('subHeader')}
            subtitleRichText={resource.metaField('subHeader').attr('hint') === 'richtext'}
          />
          <FDStack direction="column" spacing={4}>
            <ConnectionsPageActions
              connectionPageResource={resource}
              addInstitution={onAddInstitution}
            />
            <ConnectionsSection
              connectionsCollection={resource.attr('connections')}
              onEditLineItemClick={onEditLineItemClick}
              onActionSuccess={onActionSuccess}
              onUnlinkSuccess={onUnlinkSuccess}
            />
          </FDStack>
        </FDStack>
      </FDContentContainer>
    </>
  );
};

ConnectionsPageTemplate.defaultProps = {
};

ConnectionsPageTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};
